// extracted by mini-css-extract-plugin
export default {"card":"AssignedUsers_card__PFmzi","dark":"AssignedUsers_dark__w0OuU","select":"AssignedUsers_select__ewBgF"};